import React, { useCallback } from 'react';
import { Box, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

import { PlanStatuses } from '../plan.types';

import usePlanTerminationBanner from './hooks/usePlanTerminationBanner';
import { useViewPlanTermination } from './PlanTerminationModalForms/hooks/useViewPlanTermination';
import { ViewPlanTerminationModal } from './ViewPlanTerminationModal';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  opacity: 0.5;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    opacity: 1 ;
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
`;

export const PlanTerminationBanner: React.FC = () => {
  const {
    showBanner,
    bannerHeight,
    terminationDate,
    isTerminated,
    planId,
    planName,
    planStatus,
    isHsaAccount,
  } = usePlanTerminationBanner();

  const { handleOpenViewPlanTerminationModal } = useViewPlanTermination();
  const handleOpenPlanViewTerminationModal = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.stopPropagation();
      handleOpenViewPlanTerminationModal(
        planId,
        planName,
        planStatus as PlanStatuses,
        isHsaAccount,
      );
    }, [handleOpenViewPlanTerminationModal, isHsaAccount, planId, planName, planStatus]);

  if (!showBanner) return null;

  return (
    <>
      <Box
        data-testid="PlanTerminationBanner__container"
        width="100%"
        background="warningBorder"
        height={{ max: bannerHeight, min: bannerHeight }}
        justify="center"
        align="center"
        pad={{ vertical: 'spacing16'}}
      >
        <Box direction="row" align="center" height={{ max: '24px' }}>
          {isTerminated ? (
            <Inscription size="large" lineHeight="24px">
              Plan has been terminated
            </Inscription>
          ) : (
            <>
              <Inscription size="large" lineHeight="24px">
                Plan has scheduled termination on
              </Inscription>
              <Inscription size="large" weight="bold" lineHeight="24px" margin={{ left: 'spacing4' }}>
                {terminationDate}
              </Inscription>
            </>
          )}
          

          <Box
            margin={{ left: 'spacing8' }}
            onClick={handleOpenPlanViewTerminationModal}
          >
            <StyledInfoIcon size="medium" />
          </Box>
        </Box>
      </Box>
      <ViewPlanTerminationModal />
    </>
  );
};
